import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Returns true if the user is logged in
 */
function isLoggedIn(): boolean {
  return localStorage.getItem('isLogin') === 'true';
}

/**
 * Guard for protected routes — requires login
 */
export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  if (isLoggedIn()) {
    return true;
  } else {
    localStorage.setItem('redirectAfterLogin', state.url);
    router.navigate(['/auth/login']);
    return false;
  }
};

/**
 * Guard for public routes — blocks access if logged in
 */
export const noAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  if (isLoggedIn()) {
    router.navigate(['/dashboard']);
    return false;
  } else {
    return true;
  }
};
